import { Tooltip } from 'antd';
import React from 'react';
import { IFutureDelivery } from '../../../../../../../store/ducks/long-steel-orders/types';
import { Container } from './styles';

interface IEstimatedDeliveryDateColumnProps {
  futureDeliveries: IFutureDelivery[];
}

const EstimatedDeliveryDateColumn: React.FC<
  IEstimatedDeliveryDateColumnProps
> = ({ futureDeliveries }) => {
  return (
    <Container
      onClick={(e) =>
        futureDeliveries.length > 1 ? e.stopPropagation() : undefined
      }
    >
      {futureDeliveries.length === 0 && (
        <>Pedido não confirmado. Consultar Gerdau.</>
      )}

      {futureDeliveries.length === 1 && (
        <>{futureDeliveries[0].estimatedDeliveryDate}</>
      )}

      {futureDeliveries.length > 1 && (
        <Tooltip
          trigger={['hover', 'click']}
          title={
            <>
              <span>
                <strong>Data - Quantidade</strong>
              </span>
              <br />
              {futureDeliveries.map((fd, idx) => (
                <div key={idx}>
                  <span>
                    {`${fd.estimatedDeliveryDate} - ${parseFloat(
                      fd.estimatedDeliveryQuantity || '0'
                    )} ${fd.estimatedDeliveryMeasureUnit}`}
                  </span>
                  <br />
                </div>
              ))}
            </>
          }
        >
          {futureDeliveries[0].estimatedDeliveryDate} <br /> e mais{' '}
          {`${futureDeliveries.length - 1} ${
            futureDeliveries.length > 2 ? 'datas' : 'data'
          }`}
        </Tooltip>
      )}
    </Container>
  );
};

export default EstimatedDeliveryDateColumn;
